import { AdminShell } from "@project/admin/components/admin-shell";
import {
  ResourceTable,
  type Field,
} from "@project/admin/components/resource-table";

const fields: Field[] = [
  {
    name: "title",
    label: "Item Title",
    required: true,
    showInTable: true,
    placeholder: "Sponsor One Room",
  },
  {
    name: "category_id",
    label: "Category",
    lookup: { table: "donation_categories", labelField: "name" },
  },
  { name: "description", label: "Short Description", type: "textarea" },
  { name: "full_description", label: "Full Story", type: "textarea" },
  { name: "image_url", label: "Image URL", type: "url" },
  {
    name: "required_amount",
    label: "Required Amount (₹)",
    type: "number",
    required: true,
    showInTable: true,
    placeholder: "500000",
  },
  {
    name: "collected_amount",
    label: "Collected (₹)",
    type: "number",
    showInTable: true,
    help: "Updated as donations come in.",
  },
  {
    name: "partial_allowed",
    label: "Allow Partial Donations?",
    type: "boolean",
    showInTable: true,
  },
  {
    name: "recognition_applicable",
    label: "Donor Recognition?",
    type: "boolean",
    showInTable: true,
    help: "Show donor name on board/plaque.",
  },
  {
    name: "recognition_text",
    label: "Recognition Text",
    type: "textarea",
    placeholder:
      "Donor's name and family will be displayed on a plaque outside the room.",
    help: "Shown to donors so they know what recognition they get.",
  },
  {
    name: "status",
    label: "Status",
    type: "select",
    showInTable: true,
    options: ["available", "partial", "sponsored"].map(v => ({
      value: v,
      label: v,
    })),
  },
  { name: "display_on_website", label: "Show on Website", type: "boolean" },
  { name: "is_active", label: "Active", type: "boolean", showInTable: true },
  { name: "display_order", label: "Display Order", type: "number" },
];

export default function Page() {
  return (
    <AdminShell
      title="Infrastructure Donations"
      subtitle="Rooms, beds, facilities, equipment — sponsor with donor recognition"
    >
      <ResourceTable
        table="infrastructure_items"
        title="Infrastructure Item"
        fields={fields}
        searchFields={["title"]}
        statusField="status"
        statusFilterOptions={["available", "partial", "sponsored"]}
        totalField="collected_amount"
        orderBy="display_order"
        orderAsc
      />
    </AdminShell>
  );
}
